import { Grid } from "@material-ui/core";
import { InputCheckboxMaster, Modal, TableWrapper } from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import React from "react";
import { TableRowRuangAplicare } from "../TabRuangAplicares/TabRuangAplicares";

function ModalRuangAplicares({
  setShowModal,
  handleClickAddRuangAplicare,
  rowsRuangAplicare,
  rows,
  handleClickDeleteRuangAplicare,
  stateUpdate,
  setStateUpdate,
}) {
  return (
    <Modal title="Ruang Aplicare" width={"80%"} show={setShowModal}>
      <Grid container spacing={2} justifyContent="flex-end">
        <Grid item sm={12}>
          <InputCheckboxMaster
            checked={stateUpdate}
            name="udpate_aplicares"
            id="udpate_aplicares"
            label="Update APLICARES"
            onChange={(e) => {
              setStateUpdate(!stateUpdate);
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableListRuangAplicare
            rows={rows}
            clickSelect={handleClickAddRuangAplicare}
            isSelect={true}
            isUpdate={false}
            title="Ruang Aplicare"
          />
        </Grid>
        <Grid item sm={6}>
          <TableListRuangAplicare
            rows={rowsRuangAplicare}
            clickDelete={handleClickDeleteRuangAplicare}
            isSelect={false}
            isUpdate={false}
            title="Ruang Aplicare Gol Kelas"
          />
        </Grid>
      </Grid>
    </Modal>
  );
}

const TableListRuangAplicare = ({
  rows,
  clickSelect,
  clickDelete,
  isSelect,
  isUpdate,
  title,
}) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  return (
    <TableWrapper
      title={title}
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
    >
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRowRuangAplicare
              index={index}
              row={row}
              isSelect={isSelect}
              isUpdate={isUpdate}
              clickSelect={clickSelect}
              clickDelete={clickDelete}
              key={index}
            />
          );
        })}
    </TableWrapper>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "kode_sirsonline",
    disablePadding: false,
    label: "KODE SIRSONLINE",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export default ModalRuangAplicares;
